import React, { useEffect } from 'react'
import { useLocale } from '../../../extensions/Locale/useLocale'
import { Helmet } from 'react-helmet'
import POconstants from '../../../Utils/POconstants.js'
import useReportMap from './useReportMap'
import FilterSelection from './FilterSelection/FilterSelection'

const ReportMap = () => {
    const { lang } = useLocale<Locale.Keys>()
    const service = useReportMap()
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <>
            <Helmet>
                <meta name="description" content={lang.pageDescription} />
                <meta charSet="utf-8" />
                <title>{lang.titles.reportMap}</title>
                <link rel="alternate" hrefLang="hr" href={POconstants.siteLinks.reportsMap}></link>
                <link rel="alternate" hrefLang="en" href={POconstants.siteLinks.reportsMap + '?lang=en'}></link>
                <link rel="alternate" hrefLang="x-default" href={POconstants.siteLinks.reportsMap + '?lang=en'}></link>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <div className="pageContent">
                {service.mapComponent}
                <FilterSelection filters={service.filters} filters_set={service.filters_set} />
                {/* <div id="map" style={{ width: '1000px', height: '400px' }}></div> */}
            </div>
        </>
    )
}

export default ReportMap
